import Skeleton from '@components/skeleton'
import './index.scss'

const OpenIssuesSkeleton = () => {
    return (
        <Skeleton>
            <div className="open-issues-content">
                {[1, 2, 3].map((i) => (
                    <div key={i} className="item">
                        <div className="body">
                            <div id="card">
                                <div className="card-image">
                                    <div className="circle pulsate"></div>
                                    <div className="block2 pulsate"></div>
                                </div>
                                <div className="card-content">
                                    <div className="block pulsate"></div>
                                    <div className="block-btn pulsate"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </Skeleton>
    )
}

export default OpenIssuesSkeleton
